// extracted by mini-css-extract-plugin
export default {"footer":"Checkout_footer__NaIYb"};